<template>
  <div>
    <!--    SHARE REVIEWS MODAL -->
    <b-modal
      id="share-review-modal"
      hide-footer
      hide-header
      centered
      size="lg"
      content-class="p-2 text-center bg-light styled-modal centered"
    >
      <h6 class="new-modal-title mb-3">
        {{ $t('lang.reviews.review_success') }} 🫶🏼
      </h6>

      <h5 class="mt-0 mb-2">
        {{ $t('lang.reviews.share_review') }}
      </h5>

      <a
        v-if="shareReview ==='android'"
        class="btn btn_1 full-width"
        target="_blank"
        href="https://play.google.com/store/apps/details?id=app.wekeep.wekeep&reviewId=0"
      >
        <i class="fa-brands fa-google-play" /> &nbsp; {{ $t('lang.reviews.share_android') }}
      </a>
      <a
        v-if="shareReview ==='ios'"
        href="https://apps.apple.com/us/app/wekeep/id1553561341?action=write-review"
        class="btn btn_1 full-width activity-btn"
        target="_blank"
      >
        <i class="fa-brands fa-apple" /> &nbsp; {{ $t('lang.reviews.share_ios') }}
      </a>

      <a
        v-if="shareReview==='google'"
        class="btn btn_1 full-width activity-btn"
        target="_blank"
        :href="googleLink"
      >
        <i class="fa-solid fa-location-dot" /> &nbsp; {{ $t('lang.reviews.share_google') }}
      </a>

      <p
        class="mt-2 mb-3 small"
        v-html="$t('lang.reviews.comment_copied')"
      />
      <button
        class="btn btn-link activity-btn text-dark pt-2"
        @click="closeModal()"
      >
        {{ $t('lang.reviews.not_now') }}
      </button>
    </b-modal>

    <!--    THANKS MESSAGE AFTER SENDING REVIEW -->
    <div
      v-if="savedReview"
      class="col-lg-12 text-center mb-3"
    >
      <h4 class="new-modal-title mb-3">
        {{ $t('lang.reviews.review_success') }} 🫶🏼
      </h4>
      <hr>
    </div>

    <!--    LEAVE REVIEWS BLOCK -->
    <div
      v-else
      class="col-lg-12 text-center mb-3"
    >
      <h3
        id="reviews_subtitle"
        class="booking-subtitle"
      >
        {{ $t('lang.reviews.leave_review') }}
      </h3>
      <form @submit.prevent="formSubmit">
        <Errors :errors="errors" />
        <Success :success-message="successMessage" />

        <!-- 0- buttons -->
        <div
          class="btn-group justify-content-center pt-2 pb-3"
          role="group"
        >
          <button
            id="any_problem_btn"
            ref="any_problem_btn"
            type="button"
            class="btn btn-light p-4"
            :title="$t('lang.reviews.any_problem')"
            @click="show_any_problem"
          >
            <img
              class="review-icon pb-2"
              src="../../assets/img/icons/emoji_neutral.png"
            >
            <br>
            {{ $t('lang.reviews.any_problem') }}
          </button>

          <button
            id="all_ok_btn"
            ref="all_ok_btn"
            type="button"
            class="btn btn-light p-4"
            :title="$t('lang.reviews.all_ok')"
            @click="show_all_ok"
          >
            <img
              class="review-icon pb-2"
              src="../../assets/img/icons/emoji_happy.png"
            >

            <br>
            {{ $t('lang.reviews.all_ok') }}
          </button>
        </div>

        <div class="col-lg-12 p-0 centered text-left">
          <!-- 1- all_ok -->
          <div
            v-if="all_ok"
            id="all_ok"
          >
            <h6>{{ $t('lang.reviews.all_ok_title') }}</h6>

            <div
              v-for="item in items.booking_ok"
              :key="item.id"
              class="col-lg-12"
            >
              <div class="checkboxes2">
                <label class="container_check">{{ item.text }}
                  <input
                    :ref="item.id"
                    type="checkbox"
                  >
                  <span class="checkmark" />
                </label>
              </div>
            </div>
          </div>

          <!-- 2- any_problem -->
          <div
            v-if="any_problem"
            id="any_problem"
          >
            <h6>{{ $t('lang.reviews.any_problem_title') }}</h6>

            <div
              v-for="item in items.booking_not_ok"
              :key="item.id"
              class="col-lg-12"
            >
              <div class="checkboxes2">
                <label class="container_check">{{ item.text }}
                  <input
                    :ref="item.id"
                    type="checkbox"
                  >
                  <span class="checkmark" />
                </label>
              </div>
            </div>
          </div>

          <!-- 3- comment -->
          <div
            v-if="any_problem||all_ok"
            id="comment"
            class="pt-2"
          >
            <h6>{{ $t('lang.reviews.comment') }}</h6>
            <div class="col-lg-12">
              <textarea
                v-model="comment"
                class="form-control"
                rows="5"
                maxlength="255"
              />
            </div>
            <br>
            <div
              class="col-lg-12"
              style="text-align: center"
            >
              <button
                id="btn_submit"
                v-scroll-to="{el: '#reviews_subtitle', offset: -140, onStart: formSubmit}"
                type="submit"
                class="btn_1"
                name="btn_submit"
                :disabled="validatedForm"
              >
                {{ $t('lang.reviews.button_send_review') }}
              </button>
            </div>
          </div>
        </div>
      </form>
      <hr>
    </div>
  </div>
</template>

<script>

import { API, errorResponse } from '../../api/api';

import Success from '../Alerts/Success';
import Errors from '../Alerts/Errors';

const ReviewAPI = API.get('review');

export default {
  name: 'LeaveReview',

  components: {
    Success,
    Errors,
  },
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      all_ok: false,
      any_problem: false,
      comment: null,
      successMessage: null,
      errors: {},
      items: {},
      bonusPointList: [],
      validatedForm: false,
      shareReview: null,
      savedReview: false,
      googleLink: null,
    };
  },

  async beforeCreate() {
    try {
      const { data } = await ReviewAPI.getBonusPoints();
      this.items = data;
    } catch (error) {
      this.errors = errorResponse(error);
    }
  },

  methods: {
    show_all_ok() {
      this.all_ok = true;
      this.any_problem = false;
      this.$refs.all_ok_btn.classList.add('active');
      this.$refs.any_problem_btn.classList.remove('active');
    },
    show_any_problem() {
      this.all_ok = false;
      this.any_problem = true;
      this.$refs.any_problem_btn.classList.add('active');
      this.$refs.all_ok_btn.classList.remove('active');
    },

    getBonusPointList() {
      let items = {};
      this.bonusPointList = [];

      if (this.all_ok) {
        items = this.items.booking_ok;
      } else {
        items = this.items.booking_not_ok;
      }
      for (let index = 0; index < items.length; index++) {
        if (this.$refs[items[index].id][0].checked === true) {
          this.bonusPointList.push(items[index].id);
        }
      }
    },

    async formSubmit() {
      // alert();
      // e.preventDefault();
      try {
        await navigator.clipboard.writeText(this.comment);
      } catch (err) {
        // for safari
        this.fallbackCopyTextToClipboard(this.comment);
      }
      this.errors = {};
      this.getBonusPointList();

      // Validations
      if (this.comment === null || this.comment.trim() === '') {
        this.errors = { empty_comment: [this.$t('lang.reviews.empty_comment')] };
      } else {
        this.validatedForm = true;
        try {
          await ReviewAPI.leaveReview({
            booking_id: this.booking.id,
            booking_ok: this.all_ok,
            comment: this.comment,
            bonus_points: this.bonusPointList,
          });
          this.savedReview = true;

          const { app } = this.$store.state.main;
          if (this.all_ok) {
            if (app) {
              this.shareReview = app;
              // Add review query param to detect on apps
              this.$router.push({
                query: {
                  ...this.$route.query,
                  booking_ok: 'true',
                },
              });
            } else {
              this.shareReview = 'google';
              if (this.booking.store.google_maps_id) {
                this.googleLink = `https://search.google.com/local/writereview?placeid=${this.booking.store.google_maps_id}`;
              } else {
                // ask for review on Google Maps WeKeep General
                this.googleLink = 'https://search.google.com/local/writereview?placeid=ChIJeUHpWgzbNKsRsHeg9ua8ArA';
              }
            }
            this.$bvModal.show('share-review-modal');
          }
        } catch (error) {
          this.validatedForm = false;
          this.errors = errorResponse(error);
        }
      }
    },

    closeModal() {
      this.$bvModal.hide('share-review-modal');
    },

    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      // Evitar que aparezca en pantalla
      textArea.style.position = 'fixed';
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.style.width = '2em';
      textArea.style.height = '2em';
      textArea.style.padding = 0;
      textArea.style.border = 'none';
      textArea.style.outline = 'none';
      textArea.style.boxShadow = 'none';
      textArea.style.background = 'transparent';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
      } catch (err) {}

      document.body.removeChild(textArea);
    },

  },
};
</script>

<style scoped>
    .block{
        padding: 15px 30px 15px 30px;
        border-radius: 3px;
        text-align: left;
        vertical-align: middle;
    }
    .block button{
        margin: 5px;
    }

    .checkboxes2 label{
        margin-top: 15px;
        margin-bottom: 15px;
    }
    h6{
        padding-bottom: .7rem;
    }

</style>
